import { withStyles } from '@material-ui/core';
import styled from 'styled-components';

import THEME from '../../../../../constants/theme';

export const Error = styled.span`
  color: ${THEME.error};
  font-size: 14px;
  font-weight: 500;
`;

export const FlightContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1.8;
`;

export const PnrContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Span = styled.span`
  color: ${THEME.grey};
  margin-right: 10px;
  user-select: none;
`;

export const Text = styled.div`
  color: ${THEME.bobBlack};
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  margin: 0;
`;

export const Title = styled.p`
  color: ${THEME.grey};
  font-family: Montserrat;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.25;
  margin: 0 25px 0 0;
  min-width: 80px;
`;

export const Warning = styled.span`
  color: ${THEME.warning};
  font-size: 14px;
  font-weight: 500;
`;


export const withFlightPnrStyles = withStyles(theme => ({
  root: {
    borderBottom       : `1px solid ${THEME.lightGrey}`,
    display            : 'grid',
    padding            : theme.spacing(5),
    gridGap            : theme.spacing(4),
    gridTemplateColumns: '1fr',

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    '& > span': {
      width              : 'fit-content',
      display            : 'grid',
      gridTemplateColumns: '90px 1fr',
    },
  },
}));
